<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20">
        <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="info.submitHeadImg" v-if="info.submitHeadImg" :preview-src-list="[info.submitHeadImg]"></el-image>
        <img style="width: 50px; height: 50px;" src="@/assets/du_logo.png" v-else />
        <div class="ml10">
          <div class="flexs">
            <span class="font16">{{info.submitName}} {{info.submitPho}}
              【{{info.submitLevelName}}】提交的{{info.processingType | setState}}申请</span>
          </div>
        </div>
      </div>
      <div>
        <Title class="mt20">基础信息</Title>
        <el-descriptions title="" :column="3">
          <el-descriptions-item label="审批编号" label-class-name="c-8F8E8E">{{info.approvalNumber}}</el-descriptions-item>
          <el-descriptions-item label="提交时间" label-class-name="c-8F8E8E">{{info.submitTime}}</el-descriptions-item>
          <el-descriptions-item label="申请类型" label-class-name="c-8F8E8E">{{info.processingType | setState}}</el-descriptions-item>
          <el-descriptions-item label="业务员姓名" label-class-name="c-8F8E8E">{{info.customerName}}</el-descriptions-item>
          <el-descriptions-item label="身份" label-class-name="c-8F8E8E" v-if="info.processingType!=3">{{info.processingType==4?info.oldLevelName:info.sjLevelName}}</el-descriptions-item>
          <el-descriptions-item label="手机号码" label-class-name="c-8F8E8E">{{info.customerPho}}</el-descriptions-item>
          <el-descriptions-item label="原身份" label-class-name="c-8F8E8E" v-if="info.processingType==3">{{info.oldLevelName}}</el-descriptions-item>
          <el-descriptions-item label="调整身份" label-class-name="c-8F8E8E" v-if="info.processingType==3">{{info.sjLevelName}}</el-descriptions-item>
          <el-descriptions-item label="负责区域" label-class-name="c-8F8E8E" v-if="info.processingType==1">{{info.areaStr}}</el-descriptions-item>
          <el-descriptions-item label="备注" label-class-name="c-8F8E8E">{{info.remark}}</el-descriptions-item>
        </el-descriptions>
        <Title class="mt20">审批流程</Title>
        <div class="flexs">
          <div :class="info.processingStatus==1?'round':'round-active'"></div>
          <span class="ml10">审批人 · {{info.processingStatus==1?'待审核':info.processingStatus==2?'已同意':'已驳回'}}</span>
          <span class="c-8F8E8E ml20" v-if="[2,3].includes(info.processingStatus)">{{info.auditList[0].auditTime}}</span>
        </div>
        <div class="flexs">
          <div class="line" v-if="info.clevel==3"></div>
          <div class="flexs mt20">
            <el-image style="width: 35px; height: 35px;border-radius: 50%;" :src="info.auditList[0].auditHeadImg" v-if="info.auditList[0].auditHeadImg" :preview-src-list="[info.auditList[0].auditHeadImg]"></el-image>
            <img style="width: 35px; height: 35px;" src="@/assets/du_logo.png" v-else />
            <div class="ml5 ">
              <div class="flexs">{{info.auditList[0].auditName}} <div class="label-box ml10">{{info.auditList[0].auditLevelName}}</div>
              </div>
              <div class="mt5 font12 c-8F8E8E">{{info.auditList[0].auditPho}}</div>
            </div>
          </div>
        </div>
        <div class="flexs" v-if="info.clevel==3">
          <div class="round-active"></div>
          <span class="ml10">抄送人 · {{info.processingStatus==1?'未抄送':info.processingStatus==2?'已抄送':'已驳回'}}</span>
          <span class="c-8F8E8E ml20" v-if="[2,3].includes(info.processingStatus)">{{info.auditList[0].auditTime}}</span>
        </div>
        <div class="flexs mt20" v-if="info.clevel==3">
          <el-image style="width: 35px; height: 35px;border-radius: 50%;" :src="info.auditList[0].auditHeadImg" v-if="info.auditList[0].auditHeadImg" :preview-src-list="[info.auditList[0].auditHeadImg]"></el-image>
          <img style="width: 35px; height: 35px;" src="@/assets/du_logo.png" v-else />
          <div class="ml5 ">
            <div class="flexs">财务 <div class="label-box ml10">财务</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import businessProcessingApi from '@/api/user/businessProcessing'
import customerLevelApi from '@/api/sys/customerLevel'
export default {
  props: ['rowId'],
  data() {
    return {
      info: {
        customer: {},
        customerUserPO: {},
        customerLevel: {},
        customerCertificates: {},
        line: {},
        technicianInfo: {},
        userWallet: {}
      },
      listLoading: true,
      list: [],
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 3,
        isOpenSea: 0
      },
      options: [],
      customerLine: '',
      activeName: '1',
      stepList: [{
        label: '未参会',
        isActive: true
      },
      {
        label: '已参加推介会',
        isActive: false
      },
      {
        label: '已参加专题课',
        isActive: false
      },
      {
        label: '持续跟进',
        isActive: false
      },
      {
        label: '已报名研修班',
        isActive: false
      },
      ]
    }
  },
  filters: {
    setState(val) {
      switch (val) {
        case 1:
          return "招募业务员";
        case 3:
          return "修改身份";
        case 4:
          return "离职";
        default:
          return val;
      }
    }
  },
  async created() {
    // await this.getBusinessStanding()
    await this.getDetail()
    // await this.getBusinessStanding()


    // this.doQueryList({
    //   pageNo: 1
    // })
    // this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    async getDetail() {
      const {
        data
      } = await businessProcessingApi.fetchById({
        id: this.rowId
      })
      // const {data}=await clientListApi.fetchById(91)
      this.info = data
      if (this.info.processingType == 1) {
        this.info.areaStr = this.info.areaList.map(i => (i.provinceName + '' + i.districtName + '' + i.cityName)).join('、')
      }
      this.getBusinessStanding()
      console.log('详情: ', this.info, data);
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        let obj = data.find(i => i.level == this.info.clevel)
        if (obj) {
          this.$set(this.info, 'clevelName', obj.name)
        }
        let obj1 = data.find(i => i.level == this.info.submitLevel)
        if (obj1) {
          this.$set(this.info, 'submitLevelName', obj1.name)
        }
        console.log('客户身份: ', data);
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      // console.log('this.query: ',this.query,this.dateTime);
      // return
      let query = {
        ...this.query,
        mainId: this.rowId
      }
      if (this.query.timeType && this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.dateTime && this.dateTime.length && !this.query.timeType) {
        this.dateTime = null
      }
      // return
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return clientListApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data111111111: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    }
  }

}
</script>

<style lang="scss" scoped>
a:hover {
  color: #60b7dc;
}

.round-active {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #008e28;
}

.line {
  width: 1px;
  height: 70px;
  background-color: #000;
  margin: 4px 14px 4px 7px;
}

.round {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #979797;
}

.label-box {
  background: linear-gradient(180deg, #d4ab42 0%, #f2d58c 100%);
  padding: 2px 4px;
  font-size: 12px;
  color: #fff;
  // gap: 10px;
  border-radius: 8px 11px 11px 0px;
}

.step-box {
  width: 160px;
  height: 44px;
  margin-right: 10px;

  ::v-deep .el-image {
    width: 160px;
    height: 44px;
  }

  div {
    left: 0;
    top: 0;
  }
}

::v-deep.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 14px;
}
</style>
